var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ESSENTIAL_UI",
    "data-name": "ESSENTIAL UI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.2 513c-17.44 0-34.59-.39-51-1.11-33.74-1.46-65-4.3-95.66-8.69a28 28 0 0 1 8-55.43c28.78 4.12 58.26 6.8 90.12 8.18 15.68.67 32 1 48.63 1.05 16.36 0 32.55-.37 48.07-1 31.34-1.34 60.35-3.94 88.67-7.93a28 28 0 0 1 7.81 55.46c-30.14 4.24-60.91 7-94.08 8.42-16.38.61-33.36.98-50.56 1.05z",
    fill: "#34344f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.66 103.13c-9.66-43.48-51.78-83.31-95.37-91.77-26.57-5.31-100.67-11.87-149.68-11.36-49-.54-123.11 6-149.67 11.33-43.6 8.46-85.75 48.29-95.38 91.77-5.49 26.44-10.86 62.34-10.95 111.38.08 49 5.47 84.93 11 111.34 9.63 43.48 51.79 83.31 95.38 91.77 26.57 5.31 100.66 11.87 149.67 11.33 49 .54 123.11-6 149.68-11.33 43.6-8.46 85.75-48.29 95.37-91.77 5.49-26.41 10.87-62.31 11-111.34-.18-49.03-5.56-84.94-11.05-111.35z",
    fill: "#dd4247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.05 393.15a278.91 278.91 0 0 0 65.12 7.67c153.63 0 278.17-124.54 278.17-278.16a277 277 0 0 0 -25.25-115.9c-34.17-3.84-82.29-7.12-117.48-6.76-49-.54-123.11 6-149.67 11.33-43.6 8.46-85.75 48.29-95.38 91.77-5.49 26.44-10.86 62.34-10.95 111.38.08 49 5.47 84.93 11 111.34 5.62 25.59 22.57 49.92 44.44 67.33z",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339 244.45c-40.08 27.55-89.34 55.41-125.76 72.55-20.58 10.76-50.66-7.81-52.26-33.89a936.75 936.75 0 0 1 0-137.33c1.6-26.09 31.68-44.65 52.26-33.89 36.42 17.17 85.68 45 125.74 72.58a36.35 36.35 0 0 1 0 59.95z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlay);
export default __webpack_public_path__ + "static/media/youtubePlay.e78e36d4f2ffae9e9433b724b2fbb62c.svg";
export { ForwardRef as ReactComponent };